<template>
  <div class="row">
    <!-- Data Analytic-->
    <div class="col-12">
      <div class="row">
        <div class="col-lg-2 il">
          <h3 class="analytic">Data Analytic</h3>
        </div>
        <div class="col-lg-4">
          <el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels
            start-placeholder="Start date" end-placeholder="End date" @change="callClusterData()"></el-date-picker>
        </div>
        <div class="col-lg-6 text-right il">
          <base-button simple type="primary" style="margin-top: 0px" @click.native="generateReport">
            <i class="tim-icons icon-chart-bar-32"></i>
            <div style="padding-top: 3px">Generate Report</div>
          </base-button>
        </div>
      </div>
    </div>

    <!-- Savings-->
    <div class="col-12">
      <div class="row">
        <div class="head">
          <div class="col-lg">
            <h4>
              <!-- (Compared to {{ clusterOldSon }} SON) -->
              Savings | Electricity tariff : ({{ clusterTariff }} MYR per kWh)
            </h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Cost Saving (MYR) -->
    <div class="col-lg-3 col-md-3">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Cost Saving (MYR)</h5>
          <h3 class="card-title">
            <p v-html="costSaving"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Energy Saving (kWh) -->
    <div class="col-lg-3 col-md-3">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Energy Saving (kWh)</h5>
          <h3 class="card-title">
            <p v-html="energySaving"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Percentage Energy Saving -->
    <div class="col-lg-3 col-md-3">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Percentage Energy Saving (%)</h5>
          <h3 class="card-title">
            <p v-html="percentageEnergySaving"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Co2 (Kg) -->
    <div class="col-lg-3 col-md-3">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">Co2 Saving (Kg)</h5>
          <h3 class="card-title">
            <p v-html="co2"></p>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <!-- Voltage usage chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Voltage usage</h4>
            </div>
          </div>
          <card type="card-chart ">
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart v-if="voltageChart.loaded" chart-id="line-chart-1" :chart-data="voltageChart.chartData"
                    :gradient-colors="voltageChart.gradientColors" :gradient-stops="voltageChart.gradientStops"
                    :extra-options="voltageChart.extraOptions" :height="320"></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Current usage chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Current usage</h4>
            </div>
          </div>
          <card type="card-chart">
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart v-if="currentChart.loaded" chart-id="line-chart-2" :chart-data="currentChart.chartData"
                    :gradient-colors="currentChart.gradientColors" :gradient-stops="currentChart.gradientStops"
                    :extra-options="currentChart.extraOptions" :height="320"></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <!-- Energy usage chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Energy Usage</h4>
            </div>
          </div>
          <card type="card-chart">
            <template slot="header">
              <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
              <h3 class="card-title">
                <!-- <p v-html="co2"></p> -->
                <!-- chart -->
                <div class="chart-area">
                  <line-chart v-if="energyChart.loaded" chart-id="line-chart-3" :chart-data="energyChart.chartData"
                    :gradient-colors="energyChart.gradientColors" :gradient-stops="energyChart.gradientStops"
                    :extra-options="energyChart.extraOptions" :height="320"></line-chart>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>

        <!-- Light operating hours chart -->
        <div class="col-lg-6 col-md-6">
          <div class="head">
            <div class="col-lg">
              <h4>Light operating hours</h4>
            </div>
          </div>
          <div class="col-lg-12">
            <card type="card-chart-pie">
              <template slot="header">
                <!-- <h5 class="card-category">Co2 (Kg)</h5> -->
                <h3 class="card-title">
                  <!-- <p v-html="co2"></p> -->
                  <!-- chart -->
                  <div class="chart-area">
                    <pie-chart v-if="pieChart2.loaded" :chart-data="pieChart2.chartData"
                      :extra-options="pieChart2.extraOptions" :height="320"></pie-chart>
                  </div>
                </h3>
                <div slot="footer"></div>
              </template>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import moment from "moment";
import jsPDF from "jspdf";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    LineChart,
    BarChart,
    PieChart,
  },
  props: ["title"],
  data() {
    return {
      dateRange: [],
      weekdays: [],
      weekends: [],
      totalRunHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
      alteredDataset: [],
      totalDay: 0,
      deployedLightsRate: 0,
      //store cluster state
      clusterFullData: null,
      clusterTariff: null,
      clusterOldSon: null,
      clusterSchedulerWeekdays: null,
      clusterDeviceList: [],
      totalLightOn: 0,

      // Variable for getting light data
      clusterID: null,
      deviceToken: null,
      totalLights: null,

      // Savings data
      co2: 0.0,
      energySaving: 0.0,
      percentageEnergySaving: 0.0,
      costSaving: 0.0,

      // Selecting interval data
      selects: {
        selectedTime: "",
        interval: "",
        time: [
          { value: "7Days", label: "7 Days interval" },
          { value: "30Days", label: "30 Days interval" },
        ],
      },

      // Pie Chart default data
      pieChart2: {
        chartData: {
          labels: [
            "10%",
            "20%",
            "30%",
            "40%",
            "50%",
            "60%",
            "70%",
            "80%",
            "90%",
            "100%",
          ],
          datasets: [
            {
              label: "Dimm percent",
              pointRadius: 0,
              backgroundColor: [
                "#5D3FB6",
                "#3F9BB1",
                "#8EB542",
                "#FAD01A",
                "#F57C21",
                "#EF4528",
                "#CB0B5B",
                "#EF4530",
                "#CB0B0B",
                "#A9336B",
              ],
              pointHoverRadius: 0,
              borderWidth: 0,
              data: [60, 40, 20, 50, 10, 5, 8, 51, 20, 34],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "left",
            labels: {
              fontColor: "#ffffff",
            },
          },

          cutoutPercentage: 50,
        },
      },

      // Line Chart default data
      voltageChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      currentChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
      energyChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: false,
      },
    };
  },
  methods: {
    getClusterDetails() {
      this.clusterID = this.$route.params.clusterid;

      this.$http
        .get(":8002/api/v1/manage/cluster/" + this.clusterID)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            this.clusterFullData = res.message;
            let data = res.message;

            //get attribute data
            data.cluster_attribute.map((i) => {
              i.key == "CLUSTER_TARIFF_RATE"
                ? (this.clusterTariff = parseFloat(i.value))
                : 0;
              i.key == "CLUSTER_OLD_SON"
                ? (this.clusterOldSon = parseInt(i.value, 10))
                : 0;

              i.key == "CLUSTER_LIGHTS_WATT"
                ? (this.deployedLightsRate = parseInt(i.value, 10))
                : 0;
            });

            // console.log("STATE: ", data.schedule_info.state);

            //light ON
            if (data.schedule_info.state == "1") {
              data.schedule_info.weekdays.map((i) => {
                
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (data.schedule_info.state == "2") {
              data.schedule_info.weekends.map((i) => {
              
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            } else if (data.schedule_info.state == "3") {
              data.schedule_info.holidays.map((i) => {
                parseInt(i.slice(10, 12), 16) === 1 ? this.totalLightOn++ : 0;
              });
            }

            //get scheduler data
            // this.clusterSchedulerWeekdays = data.schedule_info.weekdays;

            //Get List of device
            this.clusterDeviceList = data.device_list;
            this.weekdays = data.schedule_info.weekdays;
            this.weekends = data.schedule_info.weekends;


            // console.log("TARIFF:", this.clusterTariff);
            // console.log("OLDSON:", this.clusterOldSon);
            // // console.log("WEEK:", this.clusterSchedulerWeekdays);
            // console.log("LIST:", this.clusterDeviceList);

            this.selects.selectedTime = this.selects.time[0].value;
            this.callClusterData();
          }
        })
        .catch((err) => { });
    },

    generateReport() {
      var doc = jsPDF("p", "mm", "a4");

      doc.setFontSize(8);
      doc.text(`Date generated : ${moment().format("LLL")}`, 5, 7);

      doc.setFontSize(18);
      doc.setFontType("bold");
      doc.text(`Data Analytic | ${moment(this.dateRange[0]).format("LL")} - ${moment(this.dateRange[1]).format("LL")}`, 5, 20);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Cost Saving (MYR)", 5, 35);
      doc.text("Energy Saving (KWh)", 85, 35);
      doc.text("Co2 (KG)", 165, 35);

      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(this.costSaving, 5, 45);
      doc.text(this.energySaving, 85, 45);
      doc.text(this.co2, 165, 45);
      doc.text(this.co2, 245, 45);

      doc.line(5, 50, 205, 50);

      let voltageChart = document.getElementById("line-chart-1");
      let currentChart = document.getElementById("line-chart-2");
      let energyChart = document.getElementById("line-chart-3");
      let brightChart = document.getElementById("pie-chart");

      let voltageImage = voltageChart.toDataURL("image/png", 1);
      let currentImage = currentChart.toDataURL("image/png", 1);
      let energyImage = energyChart.toDataURL("image/png", 1);
      let brightImage = brightChart.toDataURL("image/png", 1);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text(`Voltage usage for : ${this.selects.selectedTime}`, 7, 70);
      doc.addImage(voltageImage, "PNG", 7, 75, 95, 45);

      doc.text(`Current usage for : ${this.selects.selectedTime}`, 110, 70);
      doc.addImage(currentImage, "PNG", 110, 75, 95, 45);

      doc.text(`Energy  usage for : ${this.selects.selectedTime}`, 7, 150);
      doc.addImage(energyImage, "PNG", 7, 155, 95, 45);

      doc.text(
        `Light operating hours : ${this.selects.selectedTime}`,
        110,
        150
      );
      doc.addImage(brightImage, "PNG", 110, 155, 95, 45);

      setTimeout(function () {
        doc.save(`${moment().format("YYYY-MM-DD")}.pdf`);
      }, 5000);
    },
    initPieChart(data) {
      let brightData = [];

      for (let i = 0; i < data.length; i++) {
        brightData.push(data[i]);
      }

      brightData.sort(function (a, b) {
        return a - b;
      });

      // let newLabel = [...new Set(brightData)];

      let brightLabel = [];
      let sortedData = [];
      for (let i = 1; i <= 10; i++) {
        let _label = (i * 10).toString() + "%";
        brightLabel.push(_label);
        sortedData.push(data[i - 1])
      }


      // let prev;
      // for (var i = 0; i < brightData.length; i++) {
      //   // if (brightData[i] !== prev) {
      //     sortedData.push(brightData[i]);
      //   // // } else {
      //   // //   sortedData[sortedData.length - 1]++;
      //   // // }
      //   // prev = brightData[i];
      // }

      // console.log(brightLabel);
      // console.log(sortedData);
      // brightLabel = ["50","70","90"]
      // sortedData = [3, 5, 4]

      let chart = {
        chartData: {
          labels: brightLabel,
          datasets: [
            {
              label: "Dimm percent",
              pointRadius: 0,
              backgroundColor: [
                "#5D3FB6",
                "#3F9BB1",
                "#8EB542",
                "#FAD01A",
                "#F57C21",
                "#EF4528",
                "#CB0B5B",
                "#EF4530",
                "#CB0B0B",
                "#A9336B",
              ],
              pointHoverRadius: 0,
              borderWidth: 0,
              data: sortedData,
            },
          ],
        },
        loaded: true,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "left",
            // labels: {
            //   fontColor: "#ffffff"
            // }
          },

          cutoutPercentage: 50,
        },
      };

      this.pieChart2 = chart;
    },
    calcSavingData(energydata, interval) {
      let onLight = this.totalLightOn - 1;
      this.totalLights = this.clusterDeviceList.length;

      // // console.log("LENGTH_LIGHTSL : ", this.clusterDeviceList);
      // console.log("HOURS LIGHT ON: ", this.totalLightOn);

      let totalusage = 0;

      //CALCULATE OPERATION
      for (var i = 0; i < energydata.length; i++) {
        // console.log(clusdata.energy / 1000);
        totalusage += energydata[i].energy;
      }

      // console.log("TOTAL cluster energy data: ", totalusage);
      // console.log(
      // "TOTAL cluster energy data based on old SON: ",
      // (this.clusterOldSon / 1000) * onLight * this.totalLights * 6
      // );
      // console.log("Data interval: ", this.totalDay);

      //energy saving
      this.energySaving = (
        Math.abs(this.totalDay) *
        (this.clusterOldSon * (onLight / 1000)) *
        this.totalLights -
        totalusage
      ).toFixed(2);

      // percentage energy saving
      let a =
        Math.abs(this.totalDay) *
        (this.clusterOldSon * (onLight / 1000)) *
        this.totalLights;
      this.percentageEnergySaving = ((this.energySaving / a) * 100).toFixed(2);

      // // console.log(this.percentageEnergySaving)

      //total saving cost
      this.costSaving = (
        Math.abs(this.totalDay) *
        (this.clusterOldSon * (onLight / 1000)) *
        this.totalLights *
        this.clusterTariff -
        totalusage * this.clusterTariff
      ).toFixed(2);

      // console.log("TOTAL_ENERGY: ", this.energySaving);

      //total Co2 saved
      this.co2 = (this.energySaving * 0.694).toFixed(2);

      // // console.log("TOTAL_USAGE_TEST:RM " , this.energySaving)
      // // console.log("TOTAL_USAGE:RM " , totalusage * 0.316)
      // // console.log("OLD_USAGE_7_DAYS:RM " , (7 * (150 * (14/1000) * 0.316) * 12))
      // // console.log("OLD_ENERGY_7_DAYS:RM " , 7 * (150 * (14/1000) ) - totalusage)
      // // console.log("TOTAL_USAGE_30_DAYS:RM " , 30 * (150 * (14/1000) * 0.316))
      // // console.log("TOTAL_ENERGY_30_DAYS:RM " , 30 * (150 * (14/1000)) - totalusage)
    },
    getEnergySaving(data) {
      const tariff = this.clusterTariff;
      let daySON = this.clusterOldSon * tariff * this.totalLightOn;
      let hoursOn = 12;
      let newSON;
      let dayEnergy = [];
      let totalEnergy = 0;
      let energyData = [];

      for (let i = 0; i < data.length; i++) {
        energyData.push(data[i].energy);
      }
      // console.log(energyData);

      if (this.selectedTime == "7 Days") {
        for (let i = 0; i < energyData.length; i++) {
          dayEnergy.push(energyData[i]);
          totalEnergy = dayEnergy.reduce((a, b) => a + b, 0) / dayEnergy.length;
        }
        newSON = totalEnergy * this.totalLightOn * 7;
        // console.log(newSON);
        daySON *= 7;
        this.energySaving = (daySON - newSON).toFixed(2);
        this.costSaving = (daySON * tariff - newSON * tariff).toFixed(2);
        this.co2 = (totalEnergy * 0.694).toFixed(3);
      } else {
        for (let i = 0; i < energyData.length; i++) {
          dayEnergy.push(energyData[i]);
          totalEnergy = dayEnergy.reduce((a, b) => a + b, 0);
        }
        newSON = totalEnergy * hoursOn * 30;
        daySON *= 30;
        this.energySaving = (daySON - newSON).toFixed(2);
        this.costSaving = (daySON * tariff - newSON * tariff).toFixed(2);
        this.co2 = (totalEnergy * 0.694).toFixed(3);
      }
    },
    initLineGraph(param, data) {
      let clusdata = null;
      let date = null;
      let arr1 = [];
      let arr2 = [];
      let label;

      // console.log(param);
      // console.log(data);


      label = "Daily ";
      console.log(data)
      for (let i = 0; i < data.length; i++) {
        // clusdata = JSON.parse(JSON.parse(data[i].value));
        // console.log(JSON.parse(JSON.parse(data[i].value)))

        date = data[i].date;
        if (param == "voltage") {
          arr1.push(moment(data[i].date).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
          arr2.push(data[i].voltage); //y-axis
        } else if (param == "current") {
          arr1.push(moment(data[i].date).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
          arr2.push((data[i].current).toFixed(2)); //y-axis

        } else if (param == "energy") {
          arr1.push(moment(data[i].date).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
          arr2.push((data[i].energy).toFixed(2)); //y-axis
          let _totalEnergy = data[i].energy;
          this.totalEnergy = _totalEnergy.toString();
        }
      }

      // for (let i = 0; i < data.length; i++) {
      //   clusdata = JSON.parse(JSON.parse(data[i].value));

      //   date = data[i].timestamp;
      //   if (param == "voltage") {
      //     arr1.push(moment.unix(data[i].timestamp).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
      //     arr2.push(clusdata.voltage); //y-axis
      //   } else if (param == "current") {
      //     arr1.push(moment.unix(data[i].timestamp).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
      //     arr2.push(
      //       (clusdata.energy / this.totalLightOn / clusdata.voltage).toFixed(2)
      //     ); //y-axis
      //   } else if (param == "energy") {
      //     arr1.push(moment.unix(data[i].timestamp).format("MMM Do")); //toLocaleTimeString javascript method //x-axis
      //     arr2.push(clusdata.energy / 1000); //y-axis
      //     let _totalEnergy = clusdata.energy / 1000;
      //     this.totalEnergy = _totalEnergy.toString();
      //   }
      // }

      let unit;
      if (param == "voltage") {
        unit = " (V)";
      } else if (param == "current") {
        unit = " (A)";
      } else if (param == "energy") {
        unit = " (kWh)";
      }

      let chart = {
        chartData: {
          labels: arr1,
          datasets: [
            {
              label: label + param + unit,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: arr2,
            },
          ],
        },
        extraOptions: chartConfigs.testChart,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.voltageChart = chart;
      } else if (param == "current") {
        this.currentChart = chart;
      } else if (param == "energy") {
        this.energyChart = chart;
      }
    },
    callClusterData() {
      this.voltageChart.loaded = false;
      this.currentChart.loaded = false;
      this.energyChart.loaded = false;
      this.energySaving = 0;
      this.costSaving = 0;
      this.co2 = 0;
      this.alteredDataset = []

      let start;
      let end;
      // console.log("SINI" + this.dateRange[0]);
      // console.log("SINI" + this.dateRange[1]);

      let checkDate1 = moment(this.dateRange[0]).format("YYYY-MM-DD");
      let checkDate2 = moment(this.dateRange[1]).format("YYYY-MM-DD");
      // console.log(checkDate1 == checkDate2);

      if (checkDate1 === checkDate2) {
        let temp = moment(this.dateRange[0]);
        // console.log(temp);
        start = temp.startOf("day").unix();
        end = temp.endOf("day").unix();
      } else {
        start = moment(this.dateRange[0]).startOf("day").unix();
        end = moment(this.dateRange[1]).endOf("day").unix();
      }

      this.totalDay = (end - start) / 86400 + 1;

      // console.log("Today:" + start);
      // console.log("Later: " + end);
      // console.log("interval: " + this.totalDay);

      //GENERATE RANGE
      let dateRange = []
      let diffDuration = moment.duration(moment(checkDate2).
        diff(moment(checkDate1)))
      // console.log("DURATION: ", diffDuration.asDays())
      let strt = moment(checkDate1)
      for (let i = 0; i <= diffDuration.asDays(); i++) {
        strt = moment(checkDate1).add(i, "days");
        let obj = {}

        obj["date"] = strt.format("YYYY-MM-DD")
        obj["day"] = strt.day()
        dateRange.push(obj)
      }

      console.log("RANGE: ", dateRange)

      //PREPARE DATA
      for (let i = 0; i < dateRange.length; i++) {
        let schedule = []
        let sumTotalEnergy = 0
        let sumTotalCurrent = 0
        if (dateRange[i].day == 6 || dateRange[i].day == 0) {
          schedule = this.weekends
        } else {
          schedule = this.weekdays
        }

        // console.log(schedule)
        // //ITERATE EACH GET ENERGY TOTAL FOR DAY 
        for (let s = 0; s < schedule.length; s++) {

          if (s + 1 != schedule.length) {
            //GET WATT
            // console.log("B: ", parseInt(schedule[i].slice(12, 14), 16) * 10)
            let w = parseFloat(this.deployedLightsRate * ((parseInt(schedule[s].slice(12, 14), 16) * 10) / 100))

            console.log(this.clusterDeviceList.length)
            console.log("POWER: ", this.totalLightOn)
            //GET RUNNING TIME 
            let time1 = moment(parseInt(schedule[s].slice(6, 8), 16).toString() + ":" +
              parseInt(schedule[s].slice(8, 10), 16).toString(), "HH:mm")
            let time2 = moment(parseInt(schedule[s + 1].slice(6, 8), 16).toString() + ":" +
              parseInt(schedule[s + 1].slice(8, 10), 16).toString(), "HH:mm")
            let duration = moment.duration(time2.diff(time1));
            let runningHour = parseFloat(duration.asHours());

            //IF 23 to 0 , FLAG AS 1 HOUR DIFF
            if (s == 5) {
              runningHour = 1
            }


            //SUM LIGHT RUN HOURS 
            let brightLevel = parseInt(schedule[s].slice(12, 14), 16)
            this.totalRunHours[brightLevel - 1] += runningHour
            sumTotalEnergy += (w * runningHour) / 1000
            sumTotalCurrent +=  parseFloat((this.deployedLightsRate / 245) * ((parseInt(schedule[s].slice(12, 14), 16) * 10) / 100))
          }
        }


        let eachDay = {}
        eachDay["voltage"] = 245
        eachDay["current"] = (sumTotalCurrent / this.totalLightOn) * this.clusterDeviceList.length
        eachDay["energy"] = sumTotalEnergy * this.clusterDeviceList.length
        eachDay["date"] = dateRange[i].date
        this.alteredDataset.push(eachDay)
      }

      console.log("SUM: ", this.totalRunHours)

      this.resetChart("voltage");
      this.resetChart("current");
      this.resetChart("energy");

      this.initLineGraph("voltage", this.alteredDataset);
      this.initLineGraph("current", this.alteredDataset);
      this.initLineGraph("energy", this.alteredDataset);
      this.getEnergySaving(this.alteredDataset);
      this.calcSavingData(this.alteredDataset);
      this.initPieChart(this.totalRunHours);







      // this.$http
      //   .get(`:8001/api/v1/telemetry/cluster/${this.clusterID}/${start}/${end}`)
      //   .then((data) => {
      //     // console.log("CLUSTER_DATA", data.message);
      //     if (data.message.cluster_data == null) {
      //       this.resetChart("voltage");
      //       this.resetChart("current");
      //       this.resetChart("energy");
      //     } else {
      //       this.initLineGraph("voltage", data.message.cluster_data);
      //       this.initLineGraph("current", data.message.cluster_data);
      //       this.initLineGraph("energy", data.message.cluster_data);
      //       this.initPieChart(data.message.cluster_data);
      //       // this.getEnergySaving(data.message.cluster_data);
      //       this.calcSavingData(data.message.cluster_data);
      //     }
      //   });
    },
    resetChart(param) {
      let timeStamp = [];
      let today = moment().startOf("day").format("hh:mm a");

      for (let i = 0; i < 24; i++) {
        timeStamp.push(today);
        today = moment(today, "hh:mm a").add(1, "hours").format("hh:mm a");
      }

      let chart = {
        chartData: {
          labels: timeStamp,
          datasets: [
            {
              label: "Weekly " + param,
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        loaded: true,
      };

      if (param == "voltage") {
        this.voltageChart = chart;
      } else if (param == "current") {
        this.currentChart = chart;
      } else if (param == "energy") {
        this.energyChart = chart;
      }

      let chartData = {
        labels: ["10"],
        datasets: [
          {
            label: "Dimm percent",
            pointRadius: 0,
            backgroundColor: [
              "#5D3FB6",
              "#3F9BB1",
              "#8EB542",
              "#FAD01A",
              "#F57C21",
              "#EF4528",
              "#CB0B5B",
              "#EF4530",
              "#CB0B0B",
              "#A9336B",
            ],
            pointHoverRadius: 0,
            borderWidth: 0,
            data: [1],
          },
        ],
      };
      this.pieChart2.chartData = chartData;
      this.pieChart2.loaded = true;
    },
  },
  mounted() { },
  created() {
    const today1 = new Date();
    console.log(today1)
    const today = new Date((new Date()).valueOf() - 1000*60*60*24);;
    console.log(today)
    const lastWeek = new Date(today);
    lastWeek.setDate(lastWeek.getDate() - 7);
    this.dateRange.push(lastWeek, today);
    this.getClusterDetails();
  },
};
</script>

<style scoped>
.analytic el-select {
  display: inline;
}

.il {
  display: inline;
}

#line-chart-1 {
  background: transparent;
}
</style>
